import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-itams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-itams.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { ViewApplicationDetailsItamsConstants } from "./view-application-details-Itams.constants";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ViewApplicationService } from "../../../view-application.service";
import { ActivatedRoute, Router } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CreateApplicationDetailsItamsConstants } from "../../../../create-application/modules/it/create-application-details-itams/create-application-details-itams.constants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { AlertType } from "../../../../../shared/models/alert";
import { SaShortDatePipe } from "../../../../../shared/pipes/sa-short-date/sa-short-date.pipe";
import { UserInformationService } from "../../../../../shared/services/user/user-information.service";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { ViewApplicationRoutingConstants } from "../../../view-application-routing.constants";
import { InformalTradeService } from "../../../../../shared/services/modules/informal-trade.service";
import { ViewApplicationDetailsTpamsConstants } from "../../tp/view-application-details-tpams/view-application-details-tpams.constants";
import { take, takeUntil } from "rxjs/operators";
let ViewApplicationDetailsItamsComponent = class ViewApplicationDetailsItamsComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    viewApplicationService;
    route;
    router;
    informalTradeService;
    saShortDatePipe;
    userInformationService;
    routerParamsService;
    appController;
    changeDetectorRefs;
    // Labels
    saveBtnPlaceholder = ViewApplicationDetailsItamsConstants.SAVE_BUTTON_PLACEHOLDER;
    descriptionLabel = ViewApplicationDetailsItamsConstants.DESCRIPTION_LABEL;
    applicationTypeLabel = ViewApplicationDetailsItamsConstants.APPLICATION_TYPE_LABEL;
    tradingGoodsLabel = ViewApplicationDetailsItamsConstants.TRADING_GOODS_LABEL;
    tradingGoodsDescriptionLabel = ViewApplicationDetailsItamsConstants.TRADING_GOODS_DESCRIPTION_LABEL;
    referenceNumberLabel = ViewApplicationDetailsItamsConstants.REFERENCE_NUMBER_LABEL;
    detailsFormGroupName = ViewApplicationDetailsItamsConstants.DETAILS_FORM_GROUP_NAME;
    previousApplicationReferenceNumberLabel = ViewApplicationDetailsItamsConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_LABEL;
    validFromDateLabel = ViewApplicationDetailsItamsConstants.VALID_FROM_DATE_LABEL;
    validToDateLabel = ViewApplicationDetailsItamsConstants.VALID_TO_DATE_LABEL;
    approvedByLabel = ViewApplicationDetailsItamsConstants.APPROVED_BY_LABEL;
    approvalDateLabel = ViewApplicationDetailsItamsConstants.APPROVAL_DATE_LABEL;
    commentsLabel = ViewApplicationDetailsItamsConstants.COMMENTS_LABEL;
    openPreviousApplicationButtonLabel = ViewApplicationDetailsItamsConstants.OPEN_PREVIOUS_APPLICATION_BUTTON_LABEL_LABEL;
    tradeGoodsFormArray = CreateApplicationDetailsItamsConstants.TRADING_GOODS_FORM_ARRAY_NAME;
    tradeGoodsFormControlName = CreateApplicationDetailsItamsConstants.TRADING_GOODS_CONTROL_NAME;
    addTradingGoodsLabel = CreateApplicationDetailsItamsConstants.ADD_TRADING_GOODS_LABEL;
    deleteTradingGoodsLabel = CreateApplicationDetailsItamsConstants.REMOVE_TRADING_GOODS_LABEL;
    // Form controls
    descriptionFormControlName = ViewApplicationDetailsItamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = ViewApplicationDetailsItamsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    tradingGoodsFormControlName = ViewApplicationDetailsItamsConstants.TRADING_GOODS_CONTROL_NAME;
    tradingGoodsDescriptionFormControlName = ViewApplicationDetailsItamsConstants.TRADING_GOODS_DESCRIPTION_FORM_CONTROL_NAME;
    referenceNumberFormControlName = ViewApplicationDetailsItamsConstants.REFERENCE_NUMBER_FORM_CONTROL_NAME;
    previousApplicationReferenceNumberFormControlName = ViewApplicationDetailsItamsConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_CONTROL_NAME;
    validFromDateFormControlName = ViewApplicationDetailsItamsConstants.VALID_FROM_DATE_CONTROL_NAME;
    validToDateFormControlName = ViewApplicationDetailsItamsConstants.VALID_TO_DATE_CONTROL_NAME;
    approvedByFormControlName = ViewApplicationDetailsItamsConstants.APPROVED_BY_CONTROL_NAME;
    approvalDateFormControlName = ViewApplicationDetailsItamsConstants.APPROVAL_DATE_CONTROL_NAME;
    commentsFormControlName = ViewApplicationDetailsItamsConstants.COMMENTS_CONTROL_NAME;
    // Constants
    validationMessages = ViewApplicationDetailsItamsConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    // Variables
    detailsForm;
    applicationTypes = [];
    tradingGoods = [];
    tradingGoodIsRequired = false;
    showPreviousApplicationReferenceNumberField = false;
    application;
    showTradingGoodsBtn = true;
    getUserByIdSubscription;
    getInformalTradeApplicationObservableSubscription;
    setTradingObservableSubscription;
    getApplicationSaveObservableSubscription;
    getApplicationSubscription;
    getLookupsObservableSubscription;
    constructor(aflaModuleStrategyService, viewApplicationService, route, router, informalTradeService, saShortDatePipe, userInformationService, routerParamsService, appController, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.viewApplicationService = viewApplicationService;
        this.route = route;
        this.router = router;
        this.informalTradeService = informalTradeService;
        this.saShortDatePipe = saShortDatePipe;
        this.userInformationService = userInformationService;
        this.routerParamsService = routerParamsService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        if (this.aflaModuleStrategyService.lookups.has(CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME)) {
            this.applicationTypes = this.aflaModuleStrategyService.lookups.get(CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME);
            if (this.aflaModuleStrategyService.lookups.has(CreateApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME)) {
                this.tradingGoods = this.aflaModuleStrategyService.lookups.get(CreateApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME);
            }
            this.getApplication();
        }
        else {
            this.getLookups();
        }
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    getTradingGoods() {
        const tradeGoodsFormArray = this.detailsForm.get("tradeGoods");
        return tradeGoodsFormArray;
    }
    getApplication() {
        const params = {
            $expand: `TradeGoods`,
            $filter: `jobId eq ${this.jobID}`,
        };
        this.getApplicationSubscription = this.viewApplicationService.getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => {
                this.onGetApplicationCompleted(response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsItamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onBtnSaveClicked() {
        if (this.detailsForm.valid) {
            const tradingGoodsFormArray = this.getTradingGoods();
            const itApplication = {
                tradeGoods: []
            };
            tradingGoodsFormArray.controls.forEach(tradeGoodControl => {
                const tradeGoods = {
                    id: tradeGoodControl.get("id").value,
                    applicationId: tradeGoodControl.get("applicationId").value,
                    tradeGoods: tradeGoodControl.get("tradeGoods").value,
                    description: tradeGoodControl.get("tradingGoodsDescription").value,
                };
                itApplication.tradeGoods.push(tradeGoods);
            });
            this.getApplicationSaveObservableSubscription =
                this.viewApplicationService.getApplicationSaveObservable(this.aflaModuleStrategyService.applicationServiceUrl, this.application.id, itApplication)
                    .subscribe({
                    next: () => {
                        this.setTradingGoods(itApplication.tradeGoods);
                    },
                    error: (error) => {
                        this.appController.handleServerErrorMessage(ViewApplicationDetailsItamsConstants.STEP_TITLE, error, CRUDOperation.Update);
                    }
                });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    handleRouteChange() {
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get(this.detailsFormGroupName);
        this.detailsForm = form;
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.detailsForm.reset();
            const application = response.value[0];
            this.application = application;
            this.detailsForm.get(this.referenceNumberFormControlName).setValue(application.referenceNumber);
            this.detailsForm.get(this.referenceNumberFormControlName).disable();
            this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
            this.detailsForm.get(this.descriptionFormControlName).disable();
            this.detailsForm.get(this.applicationTypeFormControlName).setValue(application.type);
            if (application.type && application.type?.toLowerCase() === "renewal") {
                this.showPreviousApplicationReferenceNumberField = true;
                this.showTradingGoodsBtn = false;
                this.detailsForm.get(this.previousApplicationReferenceNumberFormControlName).setValue(application.previousReferenceNumber);
                this.detailsForm.get(this.previousApplicationReferenceNumberFormControlName).disable();
            }
            else {
                this.checkIfCurrentApplicationHasChildApplications(application);
                this.showPreviousApplicationReferenceNumberField = false;
                this.showTradingGoodsBtn = true;
            }
            this.detailsForm.get(this.applicationTypeFormControlName).disable();
            const tradingGoodsFormArray = this.getTradingGoods();
            tradingGoodsFormArray.clear();
            application.tradeGoods.forEach(savedTradeGood => {
                this.tradingGoods.forEach(tradeGoodLookupOption => {
                    if (tradeGoodLookupOption.value === savedTradeGood.tradeGoods) {
                        const tradingGroupForm = new FormGroup({
                            id: new FormControl(savedTradeGood.id),
                            applicationId: new FormControl(savedTradeGood.applicationId, Validators.required),
                            tradeGoods: new FormControl({
                                value: savedTradeGood.tradeGoods,
                                disabled: this.showPreviousApplicationReferenceNumberField
                            }, [Validators.required]),
                            tradingGoodsDescription: new FormControl({
                                value: savedTradeGood.description,
                                disabled: (this.showPreviousApplicationReferenceNumberField || savedTradeGood.tradeGoods.toLowerCase() !== "other") ? true : false
                            }),
                        });
                        tradingGoodsFormArray.push(tradingGroupForm);
                    }
                });
            });
            this.detailsForm.get(this.validFromDateFormControlName).setValue(this.saShortDatePipe.transform(application.validFromDate, "yyyy-MM-dd"));
            this.detailsForm.get(this.validFromDateFormControlName).disable();
            this.detailsForm.get(this.validToDateFormControlName).setValue(this.saShortDatePipe.transform(application.validToDate, "yyyy-MM-dd"));
            this.detailsForm.get(this.validToDateFormControlName).disable();
            if (application.approvedUserId && application.approvedUserId > 0) {
                this.getUserByIdSubscription = this.userInformationService.getUserById({}, application.approvedUserId).subscribe({
                    next: (userInformation) => {
                        this.detailsForm.get(this.approvedByFormControlName).setValue(`${userInformation.firstName} ${userInformation.lastName}`);
                        this.detailsForm.get(this.approvedByFormControlName).disable();
                        this.changeDetectorRefs.detectChanges();
                    },
                    error: (err) => {
                        this.appController.handleServerErrorMessage("user information", err, CRUDOperation.Get);
                    }
                });
            }
            this.detailsForm.get(this.approvalDateFormControlName).setValue(this.saShortDatePipe.transform(application.approvedDate, "yyyy-MM-dd"));
            this.detailsForm.get(this.approvalDateFormControlName).disable();
            this.detailsForm.get(this.commentsFormControlName).setValue(application.comments);
            this.detailsForm.get(this.commentsFormControlName).disable();
            this.changeDetectorRefs.detectChanges();
        }
    }
    getLookups() {
        const params = {
            $filter: `(moduleId eq ${this.appController.selectedModuleID}) and ((name eq '${CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME}' and deleted eq false) or (name eq '${CreateApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME}' and deleted eq false))`
        };
        this.getLookupsObservableSubscription = this.viewApplicationService
            .getLookupsObservable(params).subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationDetailsItamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        const tradingGoods = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name?.trim().toLowerCase() === `${CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME?.trim().toLowerCase()}`) {
                    applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name?.trim().toLowerCase() === `${CreateApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME?.trim().toLowerCase()}`) {
                    tradingGoods.push(JSON.parse(item.content));
                }
            });
            this.aflaModuleStrategyService.lookups.set(`${CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME}`, applicationTypes);
            this.aflaModuleStrategyService.lookups.set(`${CreateApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME}`, tradingGoods);
            this.applicationTypes = applicationTypes;
            this.tradingGoods = tradingGoods;
            this.changeDetectorRefs.detectChanges();
        }
        this.getApplication();
    }
    onOpenPreviousApplication() {
        const previousApplicationReferenceNumber = this.application.previousReferenceNumber;
        this.getApplicationByReferenceNumber(previousApplicationReferenceNumber);
    }
    getApplicationByReferenceNumber(previousApplicationReferenceNumber) {
        const params = {
            $filter: `referenceNumber eq '${previousApplicationReferenceNumber}' and deleted eq false`,
            $expand: "bays, TradeGoods"
        };
        this.getInformalTradeApplicationObservableSubscription = this.informalTradeService.getInformalTradeApplicationObservable(params).subscribe({
            next: (response) => {
                if (response && response.length > 0) {
                    const application = response[0];
                    this.navigateToApplication(application);
                }
            },
            error: (err) => {
                this.appController.handleServerErrorMessage("get application by reference number", err, CRUDOperation.Get);
            }
        });
    }
    navigateToApplication(application) {
        this.router.navigate(["/"]).then((a) => {
            this.router.navigate([
                AppRoutingConstants.createRouteToView(this.appController.selectedModuleID + "", ViewApplicationRoutingConstants.VIEW_APPLICATION_ROUTE, application.jobId + "")
            ]).then();
        });
    }
    onBtnRemoveTradingGoods(i) {
        const controls = this.getTradingGoods();
        if (controls.controls.length > 1) {
            controls.removeAt(i);
        }
    }
    onBtnAddTradingGoodsClicked() {
        const tradingGoodsControl = this.getTradingGoods();
        const tradingGoodsGroup = new FormGroup({
            id: new FormControl(0, [Validators.required]),
            tradeGoods: new FormControl(null, [Validators.required]),
            tradingGoodsDescription: new FormControl({ value: null, disabled: true })
        });
        tradingGoodsControl.push(tradingGoodsGroup);
    }
    onTradingGoodsSelected($event, i) {
        const selectedTradingGoods = $event.target?.value;
        const tradingGoodsDescriptionFormControl = this.getTradingGoods().controls[i].get(this.tradingGoodsDescriptionFormControlName);
        if (selectedTradingGoods && selectedTradingGoods.trim().toLowerCase() === "other") {
            tradingGoodsDescriptionFormControl.enable();
            tradingGoodsDescriptionFormControl.reset();
            tradingGoodsDescriptionFormControl.addValidators(Validators.required);
            tradingGoodsDescriptionFormControl.updateValueAndValidity();
            this.tradingGoodIsRequired = true;
        }
        else {
            tradingGoodsDescriptionFormControl.clearValidators();
            tradingGoodsDescriptionFormControl.reset();
            tradingGoodsDescriptionFormControl.updateValueAndValidity();
            tradingGoodsDescriptionFormControl.disable();
            this.tradingGoodIsRequired = false;
        }
        this.changeDetectorRefs.detectChanges();
    }
    setTradingGoods(tradeGoods) {
        const tradeGoodsParams = {
            tradeGoods
        };
        this.setTradingObservableSubscription =
            this.informalTradeService.setTradingObservable(this.application.id, tradeGoodsParams).subscribe({
                next: () => {
                    this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                }, error: (error) => {
                    this.appController.handleServerErrorMessage(ViewApplicationDetailsTpamsConstants.STEP_TITLE, error, CRUDOperation.Update);
                }
            });
    }
    checkIfCurrentApplicationHasChildApplications(application) {
        const params = {
            $filter: `previousReferenceNumber eq '${application.referenceNumber}' and deleted eq false`,
        };
        this.getApplicationSaveObservableSubscription = this.viewApplicationService.getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .subscribe({
            next: (response) => {
                this.checkIfCurrentApplicationHasChildApplicationsCompleted(response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsItamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    checkIfCurrentApplicationHasChildApplicationsCompleted(response) {
        if (response.value.length > 0) {
            this.showTradingGoodsBtn = false;
        }
        else {
            this.showTradingGoodsBtn = true;
        }
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ViewApplicationService },
        { type: ActivatedRoute },
        { type: Router },
        { type: InformalTradeService },
        { type: SaShortDatePipe },
        { type: UserInformationService },
        { type: RouterParamsService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationDetailsItamsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-details-itams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsItamsComponent);
export { ViewApplicationDetailsItamsComponent };
